interface SkillField {
  appearance: number;
  conversationStyle: number;
  alcoholTolerance: number;
  atmosphere: number;
}

interface HostPayload {
  clubId: string;
  hostId?: string;
  hostCode?: string;
  dobYear: string;
  dobMonth: string;
  dobDay: string;
  hostName: string;
  furigana: string;
  description?: string;
  tag?: string;
  rank: string;
  position: string;
  birthPlace: string;
  bloodType: string;
  constellation: string;
  formerJob?: string;
  alcohol?: string;
  height: string;
  instagram: string;
  tiktok: string;
  line: string;
  twitter: string;
  website?: string;
  googleMap?: string;
  mbti: string;
  title: string;
  profileImage: string;
  skills: SkillField;
}

const getStringValue = (value: unknown) => (typeof value === 'string' ? value : '');
interface BuildHostPayloadParams {
  clubId: string;
  hostId?: string;
  hostCode?: string;
  formData: Record<string, unknown>;
  profileImageUrl: string;
}

export const buildHostPayload = ({
  clubId,
  hostId,
  hostCode,
  formData,
  profileImageUrl,
}: BuildHostPayloadParams): HostPayload => {
  return {
    clubId: clubId || '',
    ...(hostId && { hostId }),
    ...(hostCode && { hostCode }),
    dobYear: getStringValue(formData.dobYear),
    dobMonth: getStringValue(formData.dobMonth),
    dobDay: getStringValue(formData.dobDay),
    hostName: getStringValue(formData.hostName),
    furigana: getStringValue(formData.furigana),
    rank: getStringValue(formData.rank),
    position: getStringValue(formData.position),
    birthPlace: getStringValue(formData.birthPlace),
    bloodType: getStringValue(formData.bloodType),
    constellation: getStringValue(formData.constellation),
    height: getStringValue(formData.height),
    instagram: getStringValue(formData.instagram),
    tiktok: getStringValue(formData.tiktok),
    line: getStringValue(formData.line),
    twitter: getStringValue(formData.twitter),
    mbti: getStringValue(formData.mbti),
    title: getStringValue(formData.title),
    profileImage: profileImageUrl || '',
    skills: {
      appearance: Number(formData.skills_appearance ?? 0),
      conversationStyle: Number(formData.skills_conversationStyle ?? 0),
      alcoholTolerance: Number(formData.skills_alcoholTolerance ?? 0),
      atmosphere: Number(formData.skills_atmosphere ?? 0),
    },
  };
};
